import { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import * as EmailValidator from 'email-validator';
import { connect } from 'react-redux';
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import { useFirebase } from 'react-redux-firebase';
import { signUpAction } from '../../Firebase/actions/signUpAction';
import CustomizedSnackbars from '../Feedback';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const useStyles = makeStyles({
    field: {
        marginTop: 25,    
    },
    btn: {
        marginBottom: 25,
        marginTop: 30
    }
})
const SignUp = ({ applications, signUpAction, signUpSuccess, signUpError,  resetSuccess, resetError }) => {
    const classes = useStyles();
    const [ email, setEmail ] = useState('');
    const [ idNumber, setIdNumber ] = useState('');
    const [ password1, setPassword1 ] = useState('');
    const [ password2, setPassword2 ] = useState('');
    const [ error, setError ] = useState(null);
    const [ pwdToogle, setPwdToogle] = useState('Show Password');

    const [ openFeedback, setOpenFeedback ] =  useState(false); 
    const [ feedbackText, setFeedbackText ] =  useState(''); 
    const [ severity, setSeverity ] =  useState(null); 

    const firebase = useFirebase();

    let students = applications;

    const tooglePwdVisibility = () => {
        if(pwdToogle === 'Show Password') {     
            document.getElementById('passwordField').setAttribute("type", "text");    
            document.getElementById('passwordField2').setAttribute("type", "text");    
            setPwdToogle('Hide Password');
        }
        if(pwdToogle === 'Hide Password') { 
            document.getElementById('passwordField').setAttribute("type", "password");    
            document.getElementById('passwordField2').setAttribute("type", "password");           
            setPwdToogle('Show Password');
        } 
    }

    const doAction = (data) => {
        
        const student = data[0];
        //console.log(student);
        firebase.auth().createUserWithEmailAndPassword(student.email, password1)
            .then((userCredential) => {
                // Signed in 
                var userId = userCredential.user.uid;
                // ...
                let data =  {
                    division: student.division,
                    programme: student.programme,
                    classCode: student.classCode,
                    title: student.title, 
                    forenames: student.forenames, 
                    surname: student.surname, 
                    dob: student.dob, 
                    gender: student.gender, 
                    maritalStatus: student.maritalStatus, 
                    placeOfBirth: student.placeOfBirth, 
                    nationality: student.nationality, 
                    citizenship: student.citizenship, 
                    idNumber: student.idNumber, 
                    email: student.email, 
                    phoneNumber: student.phoneNumber, 
                    address: student.address
                }
                
                signUpAction(data, userId);
            })
            .catch((error) => {
                //console.log(error.message, error.code);
                document.getElementById('Btn').innerHTML = 'Create Account';
                toast.error('Sorry Error Occured, Please check your input.');
                
            });
    }
    //console.log(students)
    const handleSubmit = (e) => {
        e.preventDefault();

        if(email === '' || password1 === '' || password2 === '' || idNumber === ''){
            setError('Please fill out all the fields.');
        } else {
            setError(null);
            if(!EmailValidator.validate(email)){
                setError('Please provide a valid email.');
            } else {
                setError(null);
                //go to auth
                if(password1.length < 6) {
                    document.getElementById('Btn').innerHTML = 'Create Account';
                    setError('Password choice should be at least 6 characters.');   
                }
                if( password1 !== password2 ) {
                    document.getElementById('Btn').innerHTML = 'Create Account';
                    setError('Passwords do not match.');
                } else {
                    setError(null);
                    document.getElementById('Btn').innerHTML = 'Creating Account';
                    // check if the id and email and id in db match then if correct create if not display error as to application not found.
                    let student;

                    if (students) {
                        student = students.filter((stud) => {
                            return stud.idNumber === idNumber && stud.email === email && stud.applicationStatus === 'accepted' 
                        });          
                        
                        if(student.length === 0 ){
                            document.getElementById('Btn').innerHTML = 'Create Account';
                            setError('No matching records...')
                        } else {
                            doAction(student);
                        }
                        
                    }
                }
            }       
        }
    }

    useEffect(() => {
        
        if(signUpSuccess) {

            setEmail('');
            setIdNumber('');
            setPassword1('');
            setPassword2('');
            document.getElementById('Btn').innerHTML = 'Create Account';

            setFeedbackText('Your account was created, please return to the Log In Page for Automatic redirect.');
            setSeverity('success');
            setOpenFeedback(true);

            resetSuccess();
        }

        if(signUpError) {
            document.getElementById('Btn').innerHTML = 'Create Account';
            setError('Sorry Error Occured, Please check your input.');
            resetError();
        }

    }, [signUpSuccess, signUpError,  resetSuccess, resetError]);
    return ( 
        <>
            <Helmet> 
                <meta
                    name="description"
                    content="Life Long Polytechnic is Registered with the Ministry of Higher And Tertiary Education, Science and Technology Development."
                />
                <title>Sign Up</title>
            </Helmet>
            <ToastContainer />
            <div className="wrapper light-bg py-3">
                <div className="container">
                    <div className="center">
                        <h4 className="is-size-4-touch is-size-3-desktop has-text-weight-bold grey-text text-darken-2">Life Long Polytechnic</h4>
                    </div>
                    <div className="center">
                        <img src="/img/logo.png" alt="Life Long Polytechnic Logo" className="logo-form2 mb-3" />
                    </div>
                    <div className="row">
                        <div className="col s12 m8 l6 offset-m2 offset-l3 box center px-6 py-3">
                            {
                                error && <p className="mt-1 main-color-text">{error.message}</p>
                            }
                            <form  autoComplete="off" className="bb-none" onSubmit={handleSubmit}>
                                <TextField 
                                    type="email"
                                    label="Email"
                                    variant="outlined"
                                    color="secondary"
                                    className={classes.field}
                                    fullWidth
                                    onChange={(e) => setEmail(e.target.value)}
                                    value={email}
                                    // error={true}
                                />
                                <TextField 
                                    type="text"
                                    label="National ID Number"
                                    variant="outlined"
                                    color="secondary"
                                    className={classes.field}
                                    onChange={(e) => setIdNumber(e.target.value)}
                                    value={idNumber}
                                    fullWidth
                                />
                                <TextField 
                                    type="password"
                                    label="Password"
                                    variant="outlined"
                                    color="secondary"
                                    className={classes.field}
                                    onChange={(e) => setPassword1(e.target.value)}
                                    value={password1}
                                    id="passwordField"  
                                    fullWidth
                                    autoComplete="false"
                                />
                                <TextField 
                                    type="password"
                                    label="Confirm Password"
                                    variant="outlined"
                                    color="secondary"
                                    className={classes.field}
                                    fullWidth
                                    onChange={(e) => setPassword2(e.target.value)}
                                    id="passwordField2"  
                                    value={password2}
                                    autoComplete="false"
                                />
                                {
                                    pwdToogle === 'Show Password' ? (
                                        <div 
                                            className="left-align small-text has-text-weight-light mt-3 cursor-pointer"
                                            onClick={tooglePwdVisibility}
                                        >
                                            Show Password
                                        </div>
                                    ) : (
                                        <div 
                                            className="left-align small-text has-text-weight-light mt-3 cursor-pointer"
                                            onClick={tooglePwdVisibility}
                                        >
                                            Hide Password
                                        </div>
                                    )
                                }
                                <Button
                                    className={classes.btn}
                                    type="submit"
                                    color="primary"
                                    variant="contained"
                                    fullWidth
                                    id="Btn"
                                >
                                    Create Account
                                </Button>
                                <p className="mb-4"> 
                                    <Link to="/portal" className="grey-text text-darken-2 has-text-weight-medium button-text-hover">Log In</Link> 
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <CustomizedSnackbars openSuccess={openFeedback} feedbackText={feedbackText} severity={severity} />
        </>
     );
}
//signUpAction
const mapStateToProps = (state) => {
    console.log(state);
    return {
        applications: state.firestore.ordered.applications,
        signUpSuccess: state.signUp.signUpSuccess,
        signUpError: state.signUp.signUpError
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        signUpAction: (data, userId) => dispatch(signUpAction(data, userId)),
        resetSuccess: () => dispatch({ type: "SIGN_UP", success: false }),
        resetError: () => dispatch({ type: "SIGN_UP_ERR", success: false })
    };
};
 
export default compose(
    connect(mapStateToProps, mapDispatchToProps),
        firestoreConnect((ownProps) => [
            {
                collection: "applications", 
            },
    ])
)(SignUp);
